<script setup>
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';

defineProps({
  text: {
    type: String,
    default: '',
  },
  image: {
    type: String,
    default: '',
  },
  margin: {
    type: String,
    default: 'mb-14',
  },
});
</script>

<template>
  <BasicBlock :icon="['fal', 'icons']" :aria-label="$t('activities.clubs')">
    <img
      :src="image"
      class="w-auto max-h-10 mr-2 inline-block align-middle border border-gray-200"
    />
    <span :aria-label="text">{{ text }}</span>
  </BasicBlock>
</template>
